import { TopupCountry } from 'types/topup.types';

export const DEFAULT_SENDER_COUNTRY = 'JM';
export const UNKNOWN_RECEIVER_COUNTRY = 'unknown';

export const topupCountries: Array<TopupCountry> = [
  {
    name: 'Anguilla',
    codeAlpha2: 'AI',
    codeAlpha3: 'AIA',
    diallingCodes: ['1264'],
    areaCodes: ['264'],
    countryDiallingCode: '1264',
    flagIcon: '/static/flags/AI.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Antigua and Barbuda',
    codeAlpha2: 'AG',
    codeAlpha3: 'ATG',
    diallingCodes: ['1268'],
    areaCodes: ['268'],
    countryDiallingCode: '1268',
    flagIcon: '/static/flags/AG.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Aruba',
    codeAlpha2: 'AW',
    codeAlpha3: 'ABW',
    diallingCodes: ['297'],
    countryDiallingCode: '297',
    flagIcon: '/static/flags/AW.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Barbados',
    codeAlpha2: 'BB',
    codeAlpha3: 'BRB',
    diallingCodes: ['1246'],
    areaCodes: ['246'],
    countryDiallingCode: '1246',
    flagIcon: '/static/flags/BB.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Bermuda',
    codeAlpha2: 'BM',
    codeAlpha3: 'BMU',
    diallingCodes: ['1441'],
    areaCodes: ['441'],
    countryDiallingCode: '1441',
    flagIcon: '/static/flags/BM.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Bonaire',
    codeAlpha2: 'BQ',
    codeAlpha3: 'BES',
    diallingCodes: ['5997'],
    countryDiallingCode: '5997',
    flagIcon: '/static/flags/BQ.png',
    flagIconSrc: 'external',
  },
  {
    name: 'British Virgin Islands',
    codeAlpha2: 'VG',
    codeAlpha3: 'VGB',
    diallingCodes: ['1284'],
    areaCodes: ['284'],
    countryDiallingCode: '1284',
    flagIcon: '/static/flags/VG.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Cayman Islands',
    codeAlpha2: 'KY',
    codeAlpha3: 'CYM',
    diallingCodes: ['1345'],
    areaCodes: ['345'],
    countryDiallingCode: '1345',
    flagIcon: '/static/flags/KY.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Curaçao',
    codeAlpha2: 'CW',
    codeAlpha3: 'CUW',
    diallingCodes: ['5999'],
    countryDiallingCode: '5999',
    flagIcon: '/static/flags/CW.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Dominica',
    codeAlpha2: 'DM',
    codeAlpha3: 'DMA',
    diallingCodes: ['1767'],
    areaCodes: ['767'],
    countryDiallingCode: '1767',
    flagIcon: '/static/flags/DM.png',
    flagIconSrc: 'external',
  },
  {
    name: 'El Salvador',
    codeAlpha2: 'SV',
    codeAlpha3: 'SLV',
    diallingCodes: ['503'],
    countryDiallingCode: '503',
    flagIcon: '/static/flags/SV.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Fiji',
    codeAlpha2: 'FJ',
    codeAlpha3: 'FJI',
    diallingCodes: ['679'],
    countryDiallingCode: '679',
    flagIcon: '/static/flags/FJ.png',
    flagIconSrc: 'external',
  },
  {
    name: 'French Guiana',
    codeAlpha2: 'GF',
    codeAlpha3: 'GUF',
    diallingCodes: ['594'],
    countryDiallingCode: '594',
    flagIcon: '/static/flags/GF.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Grenada',
    codeAlpha2: 'GD',
    codeAlpha3: 'GRD',
    diallingCodes: ['1473'],
    areaCodes: ['473'],
    countryDiallingCode: '1473',
    flagIcon: '/static/flags/GD.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Guadeloupe',
    codeAlpha2: 'GP',
    codeAlpha3: 'GLP',
    diallingCodes: ['590'],
    countryDiallingCode: '590',
    flagIcon: '/static/flags/GP.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Guyana',
    codeAlpha2: 'GY',
    codeAlpha3: 'CUY',
    diallingCodes: ['592'],
    countryDiallingCode: '592',
    flagIcon: '/static/flags/GY.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Haiti',
    codeAlpha2: 'HT',
    codeAlpha3: 'HTI',
    diallingCodes: ['509'],
    countryDiallingCode: '509',
    flagIcon: '/static/flags/HT.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Jamaica',
    codeAlpha2: 'JM',
    codeAlpha3: 'JAM',
    diallingCodes: ['1876', '1658'],
    areaCodes: ['876', '658'],
    countryDiallingCode: '1876',
    flagIcon: '/static/flags/JM.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Martinique',
    codeAlpha2: 'MQ',
    codeAlpha3: 'MTQ',
    diallingCodes: ['596'],
    countryDiallingCode: '596',
    flagIcon: '/static/flags/MQ.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Montserrat',
    codeAlpha2: 'MS',
    codeAlpha3: 'MSR',
    diallingCodes: ['1664'],
    areaCodes: ['664'],
    countryDiallingCode: '1664',
    flagIcon: '/static/flags/MS.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Nauru',
    codeAlpha2: 'NR',
    codeAlpha3: 'NRU',
    diallingCodes: ['674'],
    countryDiallingCode: '674',
    flagIcon: '/static/flags/NR.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Papua New Guinea',
    codeAlpha2: 'PG',
    codeAlpha3: 'PNG',
    diallingCodes: ['675'],
    countryDiallingCode: '675',
    flagIcon: '/static/flags/PG.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Saint Kitts and Nevis',
    codeAlpha2: 'KN',
    codeAlpha3: 'KNA',
    diallingCodes: ['1869'],
    areaCodes: ['869'],
    countryDiallingCode: '1869',
    flagIcon: '/static/flags/KN.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Saint Lucia',
    codeAlpha2: 'LC',
    codeAlpha3: 'LCA',
    diallingCodes: ['1758'],
    areaCodes: ['758'],
    countryDiallingCode: '1758',
    flagIcon: '/static/flags/LC.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    codeAlpha2: 'VC',
    codeAlpha3: 'VCT',
    diallingCodes: ['1784'],
    areaCodes: ['784'],
    countryDiallingCode: '1784',
    flagIcon: '/static/flags/VC.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Samoa',
    codeAlpha2: 'WS',
    codeAlpha3: 'WSM',
    diallingCodes: ['685'],
    countryDiallingCode: '685',
    flagIcon: '/static/flags/WS.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Suriname',
    codeAlpha2: 'SR',
    codeAlpha3: 'SUR',
    diallingCodes: ['597'],
    countryDiallingCode: '597',
    flagIcon: '/static/flags/SR.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Tonga',
    codeAlpha2: 'TO',
    codeAlpha3: 'TON',
    diallingCodes: ['676'],
    countryDiallingCode: '676',
    flagIcon: '/static/flags/TO.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Trinidad',
    codeAlpha2: 'TT',
    codeAlpha3: 'TTO',
    diallingCodes: ['1868'],
    areaCodes: ['868'],
    countryDiallingCode: '1868',
    flagIcon: '/static/flags/TT.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Turks and Caicos Islands',
    codeAlpha2: 'TC',
    codeAlpha3: 'TCA',
    diallingCodes: ['1649'],
    areaCodes: ['649'],
    countryDiallingCode: '1649',
    flagIcon: '/static/flags/TC.png',
    flagIconSrc: 'external',
  },
  {
    name: 'Vanuatu',
    codeAlpha2: 'VU',
    codeAlpha3: 'VUT',
    diallingCodes: ['678'],
    countryDiallingCode: '678',
    flagIcon: '/static/flags/VU.png',
    flagIconSrc: 'external',
  },
];
